export const responsiveSize = {
  MODILE_MAX_WIDTH: 766,
  TABLET_MIN_WIDTH: 767,
  DESKTOP_MIN_WIDTH: 1210,
  MIDDLE_NAV_WIDTH: 1220,
};
